<template>
  <div class="hall-of-honor">
    <img class="bg" src="./images/bg3.png" alt="" />
    <div class="dressup-list-box">
      <div class="dressup-list-item" v-for="(item, index) of list" :key="index">
        <div
          class="dressup-item"
          v-for="(subItem, subIndex) of item"
          :key="subIndex"
        >
          <img :src="subItem" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import diamondPng from './images/diamond.png';
import horsePng from './images/horse.png';
import nameplatePng from './images/nameplate.png';
import launchPng from './images/launch.png';
export default {
  name: 'HallOfHonor',
  props: {
    honorData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      list: [
        [
          diamondPng,
          'https://resource.3uplay.com/gift/voice-room/box01.png',
          horsePng
        ],
        [
          'https://resource.3uplay.com/sys-feed/785c3ed8.webp',
          'https://resource.3uplay.com/sys-feed/3ebea8ce.webp',
          'https://resource.3uplay.com/sys-feed/f2597daa.webp'
        ],
        [nameplatePng, launchPng],
        [
          diamondPng,
          'https://resource.3uplay.com/gift/voice-room/box01.png',
          horsePng
        ],
        [
          'https://resource.3uplay.com/sys-feed/daa77b78.webp',
          'https://resource.3uplay.com/sys-feed/3ebea8ce.webp',
          'https://resource.3uplay.com/sys-feed/f2597daa.webp'
        ],
        [nameplatePng],
        [
          diamondPng,
          'https://resource.3uplay.com/gift/voice-room/box01.png',
          horsePng
        ],
        [
          'https://resource.3uplay.com/sys-feed/43e98ce3.webp',
          'https://resource.3uplay.com/sys-feed/3ebea8ce.webp',
          'https://resource.3uplay.com/sys-feed/f2597daa.webp'
        ],
        [nameplatePng],
        [
          diamondPng,
          'https://resource.3uplay.com/gift/voice-room/box01.png',
          horsePng
        ],
        [
          'https://resource.3uplay.com/sys-feed/1a8fe51f.webp',
          'https://resource.3uplay.com/sys-feed/3ebea8ce.webp',
          'https://resource.3uplay.com/sys-feed/f2597daa.webp'
        ],
        [nameplatePng],

        [
          'https://resource.3uplay.com/sys-feed/1a8fe51f.webp',
          'https://resource.3uplay.com/sys-feed/3ebea8ce.webp',
          'https://resource.3uplay.com/sys-feed/f2597daa.webp'
        ],
        [nameplatePng]
      ],
      activityEnd: new Date() > new Date(2024, 0, 27)
    };
  },
  watch: {},
  computed: {
    userList() {
      return this.honorData ? this.honorData.NewYearStage3EndDate || [] : [];
    },
    topList() {
      return this.userList && this.userList.length
        ? [this.userList[1], this.userList[0], this.userList[2]]
        : [];
    }
  },
  methods: {
    toPlayerDetail(userUuid) {
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.hall-of-honor {
  width: 100%;
  position: relative;
  font-size: 0;
  > .bg {
    width: 100%;
    max-width: 100%;
  }
  .dressup-list-box {
    position: absolute;
    width: 714px;
    z-index: 2;
    top: 1129px;
    left: 35px;
  }
  .dressup-list-item {
    display: flex;
    justify-content: center;
    &:nth-child(2) {
      margin-bottom: 18px;
    }
    &:nth-child(3) {
      margin-bottom: 172px;
    }
    &:nth-child(5) {
      margin-bottom: 14px;
    }
    &:nth-child(6) {
      margin-bottom: 180px;
    }
    &:nth-child(8) {
      margin-bottom: 18px;
    }
    &:nth-child(9) {
      margin-bottom: 222px;
    }
    &:nth-child(12) {
      margin-bottom: 214px;
    }
    &:nth-child(13) {
      margin-bottom: 12px;
    }
  }
  .dressup-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 207px;
    height: 154px;
    margin-right: 32px;
    margin-bottom: 135px;

    img {
      width: 167px;
      height: auto;
      max-height: 140px;
      object-fit: contain;
    }
  }
}
</style>
